import { getABTestConfig } from '@/config/abTestConfig'
import ABTestRootOutlet from '@app-studio-web/ui/components/ABTestRootOutlet'
import completePaymentLoader from '@app-studio-web/ui/loaders/completePaymentLoader'
import createAccountRoutes from '@app-studio-web/ui/pages/account/accountRoutes'
import {
  getUserLoader,
  paymentRoute,
} from '@app-studio-web/ui/pages/checkout/checkoutRoutes'
import ErrorPage from '@app-studio-web/ui/pages/ErrorPage'
import helpCenterRoutes from '@app-studio-web/ui/pages/helpCenter/helpCenterRoutes'
import signUpRoutes from '@app-studio-web/ui/pages/signUp/signUpRoutes'
import { Navigate, Outlet } from 'react-router-dom'
import AcriLandingPage from './AcriLandingPage'
import CheckoutOutlet from './baseline/checkout/CheckoutOutlet'
import baselineCheckoutRoutes from './baseline/checkout/routes'
import OnboardingOutlet from './baseline/onboarding/OnboardingOutlet'
import baselineOnboardingRoutes from './baseline/onboarding/routes'
import EmployersPage from './EmployersPage'
import ScorePreparingPage from './ScorePreparingPage'
import ThankYouPage from './ThankYouPage'

const abTestConfig = getABTestConfig()

const routes = [
  {
    element: <ABTestRootOutlet abTestConfig={abTestConfig || undefined} />,
    errorElement: <ErrorPage />,
    path: '/',
    children: [
      { index: true, element: <AcriLandingPage /> },
      { path: 'employers', element: <EmployersPage /> },
      { element: <Outlet />, path: 'account', children: createAccountRoutes() },
      {
        element: <CheckoutOutlet />,
        path: 'checkout',
        loader: getUserLoader,
        children: [
          ...baselineCheckoutRoutes,
          paymentRoute,
          {
            element: <ThankYouPage />,
            loader: completePaymentLoader,
            path: 'payment-completion',
          },
        ],
      },
      { element: <Outlet />, path: 'help-center', children: helpCenterRoutes },
      {
        element: <OnboardingOutlet />,
        path: 'onboarding',
        children: [...baselineOnboardingRoutes],
      },
      {
        element: <Outlet />,
        path: 'sign-up',
        children: signUpRoutes.map((route) =>
          route.path === 'preparing'
            ? {
                ...route,
                element: <ScorePreparingPage />,
              }
            : route,
        ),
      },
      { element: <Navigate to="/onboarding" replace />, path: '*' },
    ],
  },
]

export default routes
